export default "__VITE_ASSET__C6M1lCQO__"